import React from "react";
import { ClipboardCheck, Megaphone, HeartHandshake, PenLine, Users2, Sparkles, Star, Flag, Briefcase } from "lucide-react";
import BookChatCTA from "./BookChatCTA";
import { useContent } from "../../content/ContentContext";

const ICONS = {
  clipboard: ClipboardCheck,
  megaphone: Megaphone,
  heart: HeartHandshake,
  pen: PenLine,
  users: Users2,
  sparkles: Sparkles,
  star: Star,
  flag: Flag,
  briefcase: Briefcase,
};

export const Services = ({ calendlyUrl }) => {
  const c = useContent("services");
  const cards = Array.isArray(c.cards) ? c.cards : [];
  return (
    <section id="services" data-testid="services-section" className="sc-section sc-blush-bg">
      <div className="sc-container">
        <div className="max-w-3xl">
          <span className="sc-eyebrow">{c.eyebrow}</span>
          <h2 className="sc-h2 mt-3" data-testid="services-heading">{c.heading}</h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {cards.map((s, i) => {
            const Icon = ICONS[s.icon] || Sparkles;
            return (
              <article key={i} className="sc-card group flex flex-col" data-testid={`service-card-${i}`}>
                <span
                  className="inline-flex items-center justify-center w-11 h-11 rounded-full mb-5"
                  style={{ background: "linear-gradient(135deg, #FBEDEF, #F4DCE0)" }}
                  aria-hidden="true"
                >
                  <Icon size={19} strokeWidth={1.6} className="text-magenta" />
                </span>
                <h3 className="sc-h3">{s.title}</h3>
                <p className="mt-4 sc-body flex-1">{s.body}</p>
              </article>
            );
          })}
        </div>

        <div className="mt-12 flex flex-col items-start md:flex-row md:items-center md:justify-between gap-6">
          <p className="text-base font-body text-ink2 italic font-serif text-xl md:text-2xl">
            {c.cta_lede}
          </p>
          <BookChatCTA calendlyUrl={calendlyUrl} label={c.cta_label} testId="services-book-chat-btn" />
        </div>
      </div>
    </section>
  );
};

export default Services;
